import { getComponent } from "../utils";
import { h } from 'vue'
import { prefix } from '../prefix'
import Layout from '@/layouts/main-layout.vue'
import { LockOutlined } from "@ant-design/icons-vue";
import type { RouteRecordRaw } from "vue-router";

export const auth_routes: RouteRecordRaw[] = [
  {
    path: '/auth/list',
    name: 'auth-list',
    component: () => getComponent(`pages/auth/auth-list.vue`),
    meta: {
      title: () => 'Auth Methods',
      layout: Layout,
      is_public: false,
      menu: {
        key: 'Auth-Methods',
        label: 'Auth Methods',
        icon: () => h(LockOutlined),
        path: `${prefix}/auth/list`,
      },
    },
  },
  {
    path: '/auth/:id(\\d+)+',
    name: 'auth-details',
    component: () => getComponent(`pages/auth/auth-details.vue`),
    meta: {
      title: ({ id }: { id: string }) => `Auth Method #${id}`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/auth/new',
    name: 'auth-new',
    component: () => getComponent(`pages/auth/auth-new.vue`),
    meta: {
      title: () => `New Auth`,
      layout: Layout,
      is_public: false,
    },
  },
  {
    path: '/auth/:id(\\d+)+/edit',
    name: 'auth-edit',
    component: () => getComponent(`pages/auth/auth-edit.vue`),
    meta: {
      title: () => `Edit Auth`,
      layout: Layout,
      is_public: false,
    },
  },
]
